import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers';
import {IAdminDetails, adminInitValues as initialValues} from './AdminAddModel'
import * as Yup from 'yup'
import {Field, FormikProvider, useFormik} from 'formik'
import Select from "react-select";
import {StylesConfig} from "react-select/dist/declarations/src/styles";
import {shallowEqual, useSelector} from "react-redux";
import {RootState} from "../../../setup";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {fetchAllAdminGroups} from "../accessGroups/AccessGroupFunctions";
import CustomSelect from "../../component/customSelect/CustomSelect";

const adminSchema = Yup.object().shape({
    surname: Yup.string().required('Pole "Nazwisko" jest wymagane').nullable(),
    name: Yup.string().required('Pole "Imię" jest wymagane').nullable(),
    email: Yup.string().required('Pole "Email" jest wymagane').nullable(),
});

const AdminCreateForm: React.FC<{ chosenListItem: IAdminDetails | null, setOpen: React.Dispatch<React.SetStateAction<boolean>> }> = (props) => {
    const {chosenListItem, setOpen} = props;
    const client = useQueryClient();
    const accessToken = useSelector<RootState>(({auth}) => auth.accessToken, shallowEqual);
    const [data, setData] = useState<IAdminDetails | {}>({})
    const [initValues, setInitValues] = useState<IAdminDetails>(initialValues);

    useEffect(() => {
        if (chosenListItem) {
            setInitValues({
                ...chosenListItem,
            group: chosenListItem?.group?.id})
        } else {
            setInitValues(initialValues)
        }
    }, [chosenListItem])

    const createNewAdmin = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}api/admins`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`
            }
        })
    }

    const updateAdminById = async (adminId: string) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}api/admins/${adminId}`, {
            method: "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`
            }
        })
    }

    const adminCreateMutation = useMutation(createNewAdmin, {
        onSuccess: () => {
            client.invalidateQueries('admins')
        }
    })

    const adminEditMutation = useMutation(updateAdminById, {
        onSuccess: () => {
            client.invalidateQueries('admins')
        }
    })
    const {data: adminGroups} = useQuery("groups", () => fetchAllAdminGroups(accessToken, ""))

    const options: [] = adminGroups?.map((group: { id: string, title: string }) => {
        return {value: group.id, label: group.title}
    })
    const [loading, setLoading] = useState(false)
    const formik = useFormik<IAdminDetails>({
        initialValues: initValues,
        enableReinitialize: true,
        validationSchema: adminSchema,
        onSubmit: (values) => {
            setLoading(true)
            setData(values)
            const options = {
                onSuccess: () => {
                    setTimeout(() => {
                        setOpen(prev => !prev)
                    }, 2000)
                }
            }
            if (chosenListItem && chosenListItem.id) {
                adminEditMutation.mutate(chosenListItem.id, options)

            } else {
                adminCreateMutation.mutate(undefined, options)
            }
        },
    })

    return (
        <div className='card mb-5 mb-xl-10'>
            <div className='collapse show'>
                <FormikProvider value={formik}>
                    <form onSubmit={formik.handleSubmit} noValidate className='form'>
                        <div className='card-body border-top p-9'>
                            <div className='row mb-6 d-flex flex-sm-row flex-column'>
                                <div className='d-flex flex-column col-12 col-sm-6'>
                                    <label className='col-lg-6 col-form-label required fw-bold fs-6 '>Imię</label>

                                    <div className='col-lg-12 fv-row'>
                                        <input
                                            type='text'
                                            className='form-control form-control-lg form-control-solid'
                                            placeholder='Wprowadź imię'
                                            {...formik.getFieldProps('name')}
                                        />
                                        {formik.touched.name && formik.errors.name && (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>{formik.errors.name}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='d-flex flex-column col-12 col-sm-6'>
                                    <label className='col-lg-6 col-form-label required fw-bold fs-6'>Nazwisko</label>

                                    <div className='col-lg-12 fv-row'>
                                        <input
                                            type='text'
                                            className='form-control form-control-lg form-control-solid'
                                            placeholder='Wprowadź nazwisko'
                                            {...formik.getFieldProps('surname')}
                                        />
                                        {formik.touched.surname && formik.errors.surname && (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>{formik.errors.surname}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6 d-flex flex-sm-row flex-column'>
                                <div className='d-flex flex-column col-12 col-sm-6'>
                                    <label className='col-lg-6 col-form-label required fw-bold fs-6'>Email</label>

                                    <div className='col-lg-12 fv-row'>
                                        <input
                                            type='text'
                                            className='form-control form-control-lg form-control-solid'
                                            placeholder='Wprowadź email'
                                            {...formik.getFieldProps('email')}
                                        />
                                        {formik.touched.email && formik.errors.email && (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>{formik.errors.email}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='d-flex flex-column col-12 col-sm-6'>
                                    <label className='col-lg-6 col-form-label fw-bold fs-6'>Grupa</label>
                                    <div className='col-lg-12 fv-row'>
                                        <Field
                                            className="custom-select"
                                            name="group"
                                            options={options}
                                            component={CustomSelect}
                                            placeholder="Wybierz grupę dostępu..."
                                            isMulti={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='card-footer d-flex justify-content-end py-6 px-9'>
                            {!adminCreateMutation.isSuccess && !adminEditMutation.isSuccess &&
                                <button type='submit' className='btn btn-primary' disabled={loading}>
                                    {!loading && (chosenListItem?.id ? "Zapisz" : "Dodaj")}
                                    {loading && (
                                        <span className='indicator-progress' style={{display: 'block'}}>
                                    Zapisywanie...{' '}
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                                    )}
                                </button>}
                        </div>
                    </form>
                </FormikProvider>
                {adminEditMutation.isSuccess &&
                    <p className="text-center fw-bold" style={{color: "green", fontSize: 16}}>Zapisano!</p>}
                {adminCreateMutation.isSuccess &&
                    <p className="text-center fw-bold" style={{color: "green", fontSize: 16}}>Stworzono!</p>}
            </div>
        </div>
    )
}

export {AdminCreateForm}
